module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Bold.b631d0c8b498b00c7a9bb4f5a356e2ed.ttf";